import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";

const CareOpportunityTable = ({
  headers,
  keyNames,
  displayedData,
  loadingTable,
  convertToPascalCase,
}) => (
  <TableContainer
    component={Paper}
    style={{ maxHeight: 400, overflow: "auto", width: "auto" }}
  >
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          {headers.map((header) => (
            <TableCell
              key={header}
              style={{ fontWeight: "bold", textAlign: "center" }}
            >
              {keyNames[header] || convertToPascalCase(header)}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {loadingTable ? (
          <TableRow>
            <TableCell colSpan={headers.length} style={{ textAlign: "center" }}>
              <CircularProgress />
            </TableCell>
          </TableRow>
        ) : displayedData.length === 0 ? (
          <TableRow>
            <TableCell colSpan={headers.length} style={{ textAlign: "center" }}>
              No data available.
            </TableCell>
          </TableRow>
        ) : (
          displayedData.map((row, index) => (
            <TableRow key={index}>
              {headers.map((header) => (
                <TableCell key={header} style={{ textAlign: "center" }}>
                  {row[header] || "-"}
                </TableCell>
              ))}
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default CareOpportunityTable;
